module.exports = __webpack_public_path__ + "static/media/logo.aaf13659.png";